import { RaxBFF } from '@raxapi/booker.planner.bff.api';

interface ProcessExceptionException {
    exceptionData?: unknown;
    reason?: string;
}

export function processException(exception: ProcessExceptionException): RaxBFF.Result {
    let raxResult: RaxBFF.Result = {
        isException: true,
        actionType: RaxBFF.ResultActionType.Undefined,
        reason: 'Uknown error occured',
        success: false,
    };

    if (RaxBFF.SwaggerException.isSwaggerException(exception)) {
        const swaggerException = exception as RaxBFF.SwaggerException;
        try {
            if (swaggerException.response?.length > 0) {
                raxResult = JSON.parse(swaggerException.response);
            } else {
                raxResult.reason = 'Server connection failed';
            }
        } catch {
            if (swaggerException.message != undefined) {
                if (exception.status === 0) {
                    raxResult.reason = 'Server connection failed';
                } else {
                    raxResult.reason = swaggerException.message;
                    raxResult.exceptionData = { ...raxResult.exceptionData, message: swaggerException.message };
                }
            }
        }
    } else if (exception.exceptionData != undefined) {
        raxResult = exception as RaxBFF.Result;
    } else if (exception.reason) {
        raxResult.reason = exception.reason;
    } else {
        console.error('unknown exception object: ', exception);
    }

    console.error('Api exception occured: ', raxResult);
    return raxResult;
}
